// Real region / map data from volunteering.org.au/overseas-volunteer-programs/
const U = "/assets/img/";

export const REGIONS = [
  {
    key: "pacific",
    name: "South Pacific",
    map: U + "2019-07-south-pacific-map-1024x720.jpg",
    photo: U + "2018-08-Volunteer-Abroad-with-IVI-Fiji-placements.webp",
    blurb:
      "Village homestays, remote island teaching and nutrition outreach across the Fijian islands.",
    countries: [{ name: "Fiji", projects: 14 }],
  },
  {
    key: "sea",
    name: "South East Asia",
    map: U + "2019-07-south-east-asia-600x400.jpg",
    photo: U + "2020-04-Ubud-Construction-11.jpg",
    blurb:
      "Our biggest region turtles in Bali, elephants in Thailand, hospitals in Vietnam and more.",
    countries: [
      { name: "Bali", projects: 13, to: "/projects/volunteer-in-bali" },
      { name: "Borneo", projects: 4 },
      { name: "Cambodia", projects: 7 },
      { name: "Laos", projects: 5 },
      { name: "Philippines", projects: 6 },
      { name: "Thailand", projects: 15 },
      { name: "Timor-Leste", projects: 3 },
      { name: "Vietnam", projects: 12 },
    ],
  },
  {
    key: "asia",
    name: "South & North East Asia",
    map: U + "2019-07-south-asia.jpg",
    photo: U + "2020-04-Education-Kathmandu-NP-Feb-11.jpg",
    blurb:
      "Himalayan monasteries, Sri Lankan turtle hatcheries, Japanese village schools and Indian hospitals.",
    countries: [
      { name: "China", projects: 3 },
      { name: "India", projects: 9 },
      { name: "Japan", projects: 4 },
      { name: "Nepal", projects: 11 },
      { name: "South Korea", projects: 4 },
      { name: "Sri Lanka", projects: 10 },
    ],
  },
  {
    key: "africa",
    name: "Africa",
    map: U + "2019-07-africa.jpg",
    photo: U + "2020-02-Group-photo-at-tea-farm-1.jpg",
    blurb:
      "Wildlife conservation, sports coaching, lakeside classrooms and cheetah sanctuaries.",
    countries: [
      { name: "Cape Verde", projects: 5 },
      { name: "Ghana", projects: 11 },
      { name: "Kenya", projects: 12 },
      { name: "Madagascar", projects: 4 },
      { name: "Malawi", projects: 7 },
      { name: "Morocco", projects: 3 },
      { name: "South Africa", projects: 8 },
      { name: "Tanzania", projects: 6 },
      { name: "Uganda", projects: 5 },
      { name: "Zanzibar", projects: 4 },
    ],
  },
  {
    key: "latam",
    name: "Central & South America",
    map: U + "2019-10-latin-america-map.jpg",
    photo: U + "2020-03-medical-guatemala-1-1024x576.jpeg",
    blurb:
      "Amazon rainforest conservation, alpaca farms, Spanish-speaking clinics and eco farming.",
    countries: [
      { name: "Argentina", projects: 3 },
      { name: "Colombia", projects: 4 },
      { name: "Costa Rica", projects: 8 },
      { name: "Ecuador", projects: 5 },
      { name: "Guatemala", projects: 7 },
      { name: "Peru", projects: 9 },
    ],
  },
  {
    key: "europe",
    name: "Europe",
    map: U + "2022-07-map-g63b0e1956_1280-800x600.png",
    photo: U + "2020-03-WhatsApp-Image-2019-08-09-at-2.28.28-PM-min-1.webp",
    blurb: "Refugee support, marine conservation and community programs on the Mediterranean.",
    countries: [
      { name: "Greece", projects: 4 },
      { name: "Portugal", projects: 3 },
      { name: "Turkey", projects: 3 },
    ],
  },
];

export const CAUSES = [
  {
    name: "Teaching & Childcare",
    img: U + "2018-12-IMG_0291-1024x866.jpg",
    text: "Sports coaching, primary teaching, kindergarten and special needs care.",
  },
  {
    name: "Public Health & Nutrition",
    img: U + "2018-08-Volunteer-Abroad-with-IVI-Fiji-placements.webp",
    text: "Free health assessments and nutrition outreach with qualified practitioners.",
  },
  {
    name: "Wildlife & Animal Care",
    img: U + "2020-01-holding-Baby-Turtle.jpg",
    text: "Turtle and elephant conservation, stray dog rehab, even an alpaca farm.",
  },
  {
    name: "Construction & Renovation",
    img: U + "2020-04-Ubud-Construction-11.jpg",
    text: "Classrooms, schools, playgrounds, community centres and gardens.",
  },
  {
    name: "Medical Internships",
    img: U + "2020-03-medical-guatemala-1-1024x576.jpeg",
    text: "Shadow health professionals in rural healthcare, maternity and physio.",
  },
  {
    name: "Humanitarian Support",
    img: U + "2016-06-bodhgaya-crew3.jpg",
    text: "Disaster relief, women's empowerment and micro-business opportunities.",
  },
];
